class articleSlider extends HTMLElement {
  constructor() {
    super();

    let bannerSwiper = new Swiper('[data-blog-slider]', {
      slidesPerView: 1.2,
      loop: true,
      effect: 'slide',
      loop: false,
      speed: 1000,
      navigation: {
        nextEl: '.hero__button-next',
        prevEl: '.hero__button-prev'
      },
      pagination: {
        el: '.swiper-pagination',
        clickable: true
      },
        breakpoints: {
    768: {
      slidesPerView: 3,
    }
  },
    });
  }
}
customElements.define('blog-article-slider', articleSlider);